import { RouteConfig } from 'vue-router';

export default (): RouteConfig[] => {
	return [
		{ path: 'blog-entries', name: 'blog-list', component: () => import('@client/views/blog/BlogEntries.vue') },
	];
};
